import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${ptlEnvs.base}/usr/extauth`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/usr/extauth`,
    nodes: [],
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    ptli0924001q: `${BASE.path}/ptli0924001q`,
    ptli0924002s: `${BASE.path}/ptli0924002s`,
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    getExtUsrList: (data: any, page: number, size: number) =>
        api.get(`${BASE.api}/extAuth-user?page=${page}&size=${size}`, { params: comnUtils.toGetParams(data) }),
    getExtAuthUsrDtl: (data: any) => api.get(`${BASE.api}/extAuth-user/${data.xtrnUsrUuid}`),
    getAuthList: (data: any, page: number, size: number) =>
        api.get(`${BASE.api}/auth?page=${page}&size=${size}`, { params: comnUtils.toGetParams(data) }),
    saveExtUsrAuthList: (data: any) => api.post(`${BASE.api}`, data),
};

export const SF_EXTAUTH_SRCH: TFormSchema = {
    id: "form_extAuthSrch",
    schema: {
        xtrnUsrIdntfNo: {
            type: "text",
            label: "L_USR_ID",
        },
        usrNm: {
            type: "text",
            label: "L_USR_NM",
        },
        usrEmlAddr: {
            type: "text",
            label: "L_USR_EML_ADDR",
        },
    },
};

export const SG_EXT_USR_LIST: TGridSchema = {
    id: "grid_extUsrList",
    options: { index: true, pagination: "out" },
    head: [
        { cells: [{ header: "L_USR_ID", binding: "xtrnUsrIdntfNo", width: "4*" }] },
        { cells: [{ header: "L_USR_NM", binding: "usrNm", width: "4*" }] },
        { cells: [{ header: "L_USR_EML_ADDR", binding: "usrEmlAddr", width: "4*" }] },
    ],
    body: [
        { cells: [{ binding: "xtrnUsrIdntfNo" }] },
        { cells: [{ binding: "usrNm", align: "left" }] },
        { cells: [{ binding: "usrEmlAddr", align: "left" }] },
    ],
};

export const SF_EXT_AUTH_INFO: TFormSchema = {
    id: "form_extAuthUsrInfo",
    schema: {
        xtrnUsrUuid: {
            type: "text",
            edit: false,
        },
        xtrnUsrIdntfMethCd: {
            type: "text",
            edit: false,
        },
        xtrnUsrIdntfNo: {
            type: "text",
            label: "L_USR_ID",
            edit: false,
        },
        frgnrYn: {
            type: "text",
            label: "L_FRGNR_YN",
            edit: false,
        },
        usrNm: {
            type: "text",
            label: "L_USR_NM",
            edit: false,
        },
        usrMoblNo: {
            type: "text",
            label: "L_MOBL_NO",
            edit: false,
        },
        usrEmlAddr: {
            type: "text",
            label: "L_USR_EML_ADDR",
            edit: false,
        },
        rsdtAddr: {
            type: "text",
            label: "L_RSDT_ADDR",
            edit: false,
        },
    },
};

export const SF_AUTH_SRCH: TFormSchema = {
    id: "form_authSrch",
    schema: {
        usrDmnId: { type: "text" },
        authId: { type: "text", label: "L_AUTH_ID" },
        authNm: { type: "text", label: "L_AUTH_NM" },
    },
};

export const SG_EXT_USR_AUTH_LIST: TGridSchema = {
    id: "grid_extUsrAuthList",
    options: { checkbox: true },
    head: [
        { cells: [{ header: "L_AUTH_ID", binding: "authId", width: "*" }] },
        { cells: [{ header: "L_AUTH_NM", binding: "authNm", width: "*" }] },
    ],
    body: [{ cells: [{ binding: "authId", align: "center" }] }, { cells: [{ binding: "authNm", align: "left" }] }],
};

export const SG_SCRH_AUTH_LIST: TGridSchema = {
    id: "grid_srchAuthList",
    options: { index: true, checkbox: true, pagination: "out", height: 150 },
    head: [
        { cells: [{ header: "L_AUTH_ID", binding: "authId", width: "*" }] },
        { cells: [{ header: "L_AUTH_NM", binding: "authNm", width: "*" }] },
        { cells: [{ binding: "isRgsrYn", width: "*" }], show: false },
    ],
    body: [
        { cells: [{ binding: "authId", align: "center" }] },
        { cells: [{ binding: "authNm", align: "left" }] },
        { cells: [{ binding: "isRgsrYn", align: "center" }] },
    ],
};
